/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';

	Module.TabNavigation.DeprecatedTabs = function (parent) {
		// @Override
		this.on = function (callback) {
			this.tabContentsParents = this.$ctx.find('> .tabs > .tab');
			this.errorMessage = this.$ctx.nextAll('.tab-content-error').eq(0);
			var mod = this;

			mod.tabs = mod.$ctx.find('> .navigation-bar .tab-navigation-tab');

			// Mark first tab active if none is active
			if(!this.tabs.filter('.active').length) {
				this.tabs.eq(0).addClass('active');
			}

			// If two or more Tabs are active. Only the first will be active
			if(this.tabs.filter('.active').length > 1 ){
				this.tabs.filter('.active').not(this.tabs.filter('.active').first()).removeClass('active');
			}

			parent.on.call(this, callback);

		};

		// @Override
		this.after = function () {
			parent.after.call(this);
		};

		// @Override
		this.activateTab = function(activatedTab) {
			var mod = this;
			var tabInList = activatedTab.parent();
			var tabContentParent = mod.tabContentsParents.eq(tabInList.index());
			var panel = tabContentParent.children().eq(0);

			mod.tabContentsParents.find('> div').hide();
			mod.tabContentsParents.find('> div').attr('aria-hidden','true');

			//check if tab is lazyload and if tab already exists
			if (activatedTab.data('islazyloaded') && !panel.length) {
				//create the tabcontentParent div
				panel = $('<div role="tabpanel" class="ui-tabs-panel ui-widget-content ui-corner-bottom" aria-hidden="false"><div class="loading-indicator"></div></div>');
				tabContentParent.empty().append(panel);
				mod.loadDeprecatedTabContent(activatedTab.attr('data-url'), panel);
			} else {
				panel.show();
				panel.attr('aria-hidden','false');
				SCS.utils.initNewModules(panel);
				$(window).trigger('resize'); //only for TabNavigation
			}

			parent.activateTab.apply(this, arguments);
		};

		this.loadDeprecatedTabContent = function (url, panel) {
			var mod = this;

			$.ajax({
				url: url
			}).done(function (data) {
				mod.onLoadDeprecatedTabContentSuccess(data, panel);
			}).fail(function (jqXHR, errortype, exceptionobject) {
				mod.onLoadDeprecatedTabContentFail(jqXHR, errortype, exceptionobject, panel);
			});
		};

		this.onLoadDeprecatedTabContentSuccess = function (htmlContent, panel) {
			var mod = this;

			panel.html(htmlContent);
			mod.$ctx.trigger('create');
			SCS.utils.initNewModules(panel);
			$(window).trigger('resize'); //only for TabNavigation

		};

		this.onLoadDeprecatedTabContentFail = function (jqXHR, errortype, exceptionobject, panel) {
			var mod = this;

			panel.html(mod.errorMessage);
			panel.find('.tab-content-error').first().removeClass('hidden');
		};
	};
}(window.Tc.Module, window.Tc.$, window.SCS));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TabNavigation.DeprecatedTabs.js
// module id = 189
// module chunks = 0